import { mdlVehicleDetailsCompRenewal } from "./mdlVehicleDetailsCompRenewal";
import { mdlPreminumDetailsCompRenewal } from "./mdlPreminumDetailsCompRenewal";
import { mdlDriverNCDDetailsCompRenewal } from "./mdlDriverNCDDetailsCompRenewal";
import { mdlPolicyDetailsCompRenewal } from "./mdlPolicyDetailsCompRenewal";


export class mdlPremiumAndVehicleInfoCompRenewalRes {
    public POLICY_INFO: mdlPolicyDetailsCompRenewal = new mdlPolicyDetailsCompRenewal();
    public VEHICLE_INFO: mdlVehicleDetailsCompRenewal = new mdlVehicleDetailsCompRenewal();
    public PREMIUM_INFO: mdlPreminumDetailsCompRenewal = new mdlPreminumDetailsCompRenewal();
    public DRIVER_INFO: mdlDriverNCDDetailsCompRenewal = new mdlDriverNCDDetailsCompRenewal();
    public StatusCode: string;
    public ErrorMsg: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlPremiumAndVehicleInfoCompRenewalRes.ts